import styled from "@emotion/styled";
import { GreenButton } from "../green-button/green-button.component";

export const GreenMoreButton = styled(GreenButton)`
  padding: 0;
  min-width: 16px;
`;
